import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import Navbar from './components/layout/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './components/pages/Home/Home';
import Tradefinance from './components/pages/Tradefinance/Tradefinance';
import LPOFinancing from './components/pages/LPOFinancing/LPOFinancing';
import ContactForm from './components/pages/Tradefinance/ContactForm/ContactForm';
import PrivacyPolicy from './components/pages/PrivacyPolicy/PrivacyPolicy';
import ScrollPopup from './components/common/Popup/ScrollPopup';
import Blog from './components/pages/Blog/Blog';                    // NEW
import BlogPost from './components/pages/Blog/BlogPost'; 

function App() {
  useEffect(() => {
    if (window.location.host === 'www.trinityfinancing.com') {
      window.location.href = 'https://trinityfinancing.com' + window.location.pathname + window.location.search;
    }
  }, []);
  return (
    
      <Router>
        <div className="app">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tradefinance" element={<Tradefinance />} />
            <Route path="/LPOFinancing" element={<LPOFinancing />} />
            <Route path="/contactform" element={<ContactForm />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy /> } />
            <Route path="/blog" element={<Blog />} />                 {/* NEW */}
            <Route path="/blog/:slug" element={<BlogPost />} /> 
          </Routes>
          <ScrollPopup />
          <Footer />
        </div>
      </Router>
    
  );
}

export default App;
